module.exports = __webpack_public_path__ + "img/calendar-icon.f5659a1.png";